// extracted by mini-css-extract-plugin
export default {"overlay":"Hz-z","bodyOpen":"Iz-z","content":"Jz-z","header":"Kz-z","close":"Lz-z","closeNoHeading":"Mz-z"};